module.exports = __webpack_public_path__ + "static/tu1-9b5e81c83a76b5ddfb64b4728f94cd2f.png";